import { OwaDate } from 'owa-datetime';
import { addDatapointConfig } from 'owa-analytics-actions';
import { action } from 'satcheljs';

/**
 * action invoked when user clicks on month cell
 */
export const onMonthCellClick = action(
    'onMonthCellClick',
    (date: OwaDate, clickTarget: HTMLElement) =>
        addDatapointConfig(
            {
                name: 'onSurfaceClick', // mark the same datapoint as double click on surface, so that surface clicks on all views can be tracked together
            },
            {
                date,
                clickTarget,
            }
        )
);

/**
 * action invoked when user double clicks on month cell
 */
export const onMonthCellDoubleClick = action(
    'onMonthCellDoubleClick',
    (date: OwaDate, clickTarget: HTMLElement) =>
        addDatapointConfig(
            {
                name: 'onSurfaceDoubleClick', // mark the same datapoint as double click on surface, so that surface clicks on all views can be tracked together
            },
            {
                date,
                clickTarget,
            }
        )
);
